var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatientsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.991,
    viewBox: "0 0 20 19.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    transform: "translate(-0.006 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M86.168,87.393c-.016.17-.029.335-.045.5-.075.757-.152,1.514-.227,2.272-.064.654-.123,1.308-.191,1.962a3.943,3.943,0,0,1-.1.606,1.185,1.185,0,0,1-1.083.885c-.526.02-1.054.023-1.58,0a1.2,1.2,0,0,1-1.121-1.067c-.067-.575-.119-1.152-.178-1.728-.063-.608-.13-1.216-.191-1.825-.044-.431-.08-.862-.121-1.292-.008-.081-.019-.162-.022-.243,0-.061-.029-.076-.085-.075-.192,0-.384,0-.576,0a.616.616,0,0,1-.656-.532,1.43,1.43,0,0,1,.013-.369q.144-1.466.292-2.932.117-1.17.234-2.34a1.705,1.705,0,0,1,.147-.6,1.215,1.215,0,0,1,1.006-.707A2.966,2.966,0,0,1,82,79.886q1.749,0,3.5,0a1.6,1.6,0,0,1,.623.1,1.2,1.2,0,0,1,.779.995c.083.625.135,1.255.2,1.882q.073.7.143,1.408c.057.573.113,1.146.17,1.719.021.21.04.421.067.631a.634.634,0,0,1-.652.77c-.185,0-.371,0-.556,0-.032,0-.063,0-.1,0Z",
    transform: "translate(-73.731 -73.643)",
    fill: "#9c8eeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M5.9,79.9a2.447,2.447,0,0,0-.311.874c-.038.32-.065.641-.1.961-.069.683-.139,1.365-.207,2.048q-.095.956-.186,1.914a9.8,9.8,0,0,0-.09,1.107,1.725,1.725,0,0,0,.954,1.557.124.124,0,0,1,.075.146c-.076.567-.149,1.135-.224,1.7-.048.367-.085.737-.152,1.1a1.205,1.205,0,0,1-.929,1.007,1.335,1.335,0,0,1-.348.045c-.472,0-.945.01-1.415-.016a1.214,1.214,0,0,1-1.131-1.07c-.115-.841-.223-1.682-.335-2.524-.058-.438-.118-.877-.173-1.315-.008-.062-.036-.073-.089-.072-.189,0-.377,0-.566,0a.64.64,0,0,1-.663-.777c.059-.477.1-.958.146-1.437.056-.563.114-1.126.17-1.689.048-.482.094-.965.143-1.447.037-.359.066-.72.118-1.076a1.239,1.239,0,0,1,1.137-1.058c.123-.01.247-.016.37-.016q1.69,0,3.379,0c.134,0,.269.02.426.033Z",
    transform: "translate(0 -73.625)",
    fill: "#9c8eeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M178.866,79.939a.462.462,0,0,1,.077-.023c.1-.009.208-.023.311-.023q1.772,0,3.544,0a1.405,1.405,0,0,1,.826.219,1.292,1.292,0,0,1,.56.984c.075.718.145,1.437.218,2.155l.188,1.854c.053.524.109,1.048.159,1.572a.633.633,0,0,1-.654.717c-.2,0-.391,0-.586,0-.057,0-.078.016-.085.075q-.131,1.03-.269,2.06c-.078.593-.148,1.187-.241,1.778a1.2,1.2,0,0,1-1.163,1.067,14.008,14.008,0,0,1-1.579,0,1.192,1.192,0,0,1-1.063-.981c-.073-.416-.12-.836-.177-1.255-.07-.519-.137-1.038-.21-1.556a.165.165,0,0,1,.1-.208,1.806,1.806,0,0,0,.921-1.788c-.051-.463-.084-.927-.129-1.389-.064-.644-.134-1.287-.2-1.931s-.123-1.281-.191-1.922a3.5,3.5,0,0,0-.213-1.1c-.045-.1-.092-.2-.143-.307Z",
    transform: "translate(-164.747 -73.649)",
    fill: "#9c8eeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M21.062,2.511a2.5,2.5,0,0,1-2.514,2.475,2.467,2.467,0,0,1-2.479-2.514A2.47,2.47,0,0,1,18.572,0,2.5,2.5,0,0,1,21.062,2.511Z",
    transform: "translate(-14.808 0)",
    fill: "#9c8eeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M101.063,2.508a2.5,2.5,0,0,1-2.511,2.477A2.468,2.468,0,0,1,96.07,2.473,2.47,2.47,0,0,1,98.57,0,2.5,2.5,0,0,1,101.063,2.508Z",
    transform: "translate(-88.557 0)",
    fill: "#9c8eeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M181.063,2.507a2.5,2.5,0,0,1-2.52,2.479,2.467,2.467,0,0,1-2.473-2.51A2.469,2.469,0,0,1,178.569,0a2.5,2.5,0,0,1,2.495,2.507Z",
    transform: "translate(-162.306 0)",
    fill: "#9c8eeb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientsIcon);
export default __webpack_public_path__ + "static/media/patients-icon.4fe07abca98384ce3d67f2eb0c5f4746.svg";
export { ForwardRef as ReactComponent };